import { Box } from '@mui/material';
import { Form, useFormikContext } from 'formik';
import React, { FormHTMLAttributes, useEffect } from 'react';
import { usePrevious } from 'react-use';

import { BaseRow } from '@sbu/components.datagrid';
import { DiscardDialog } from '@sbu/components.discarddialog';

import { useDataGridPageContext } from '../DataGridPageContext/DataGridPageContext';
import { useNavigationBlocker } from './useNavigationBlock';

export const DataGridAsideForm = <Row extends BaseRow>({
  ...rest
}: FormHTMLAttributes<HTMLFormElement>) => {
  const {
    onChangeAside,
    isDiscardDialogOpen,
    onConfirmDiscard,
    onCancelDiscard,
  } = useDataGridPageContext<Row>();

  useNavigationBlocker();

  const { dirty } = useFormikContext();

  const prevDirtyState = usePrevious(dirty);

  useEffect(() => {
    prevDirtyState !== dirty && onChangeAside(dirty);
  }, [prevDirtyState, dirty, onChangeAside]);

  return (
    <>
      <Box
        component={Form}
        sx={{ overflow: 'hidden', display: 'flex', flexDirection: 'column' }}
        {...rest}
      />
      <DiscardDialog
        open={isDiscardDialogOpen}
        onCancel={onCancelDiscard}
        onConfirm={onConfirmDiscard}
      />
    </>
  );
};
